export default {
    data () {
        return {
            EmployeeDayWorkStatus: "EmployeeDayWorkStatus",
            EmployeeRole: "EmployeeRole",
            MoveTaskFlag: "TaskFlag",
            TravelBillStatus: "TravelBillStatus",
            VehicleDataChangeAction: "VehicleDataChangeAction",
            VehicleDataChangeEntityType: "VehicleDataChangeEntityType",
            VehicleDataChangeSource: "VehicleDataChangeSource",
            EmployeeStatus: "EmployeeStatus",
            EmployeeRecordType: "EmployeeRecordType",
            EmploymentRecordSource: "EmploymentRecordSource"
        }
    },
    computed: {
        arrEmployeeDayWorkStatus() {
            // 员工工作状态
            return  this.getEnumConfigs(this.EmployeeDayWorkStatus).arrs
        },
        arrEmployeeRole() {
            // 员工角色
            return  this.getEnumConfigs(this.EmployeeRole).arrs
        },
        arrMoveTaskFlag() {
            // 挪车任务状态
            return  this.getEnumConfigs(this.MoveTaskFlag).arrs
        },
        arrTravelBillStatus() {
            // 行程单状态
            return  this.getEnumConfigs(this.TravelBillStatus).arrs
        },
        arrVehicleDataChangeAction() {
            // 车辆数据变更操作
            return  this.getEnumConfigs(this.VehicleDataChangeAction).arrs
        },
        arrVehicleDataChangeEntityType() {
            // 车辆数据变更实体类型
            return  this.getEnumConfigs(this.VehicleDataChangeEntityType).arrs
        },
        arrVehicleDataChangeSource() {
            // 车辆数据变更来源
            return  this.getEnumConfigs(this.VehicleDataChangeSource).arrs
        },
        arrEmployeeStatus() {
            // 员工在职状态
            return  this.getEnumConfigs(this.EmployeeStatus).arrs
        },
        arrEmployeeRecordType() {
            // 入离职记录类型
            return  this.getEnumConfigs(this.EmployeeRecordType).arrs
        },
        arrEmploymentRecordSource() {
            // 入离职记录来源
            return  this.getEnumConfigs(this.EmploymentRecordSource).arrs
        }
    },
    methods: {
        // 入职
        valEmployeeRecordTypeHire() {
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeRecordType).objs, "Hire", "value")
        },
        // 离职
        valEmployeeRecordTypeLeave() {
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeRecordType).objs, "Leave", "value")
        },
        // 售后维修订单状态
        valEmployeeDayWorkStatusUnHandled() {
            // 未处理
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeDayWorkStatus).objs, "UnHandled", "value")
        },
        valEmployeeDayWorkStatusNormal() {
            // 正常
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeDayWorkStatus).objs, "Normal", "value")
        },
        valEmployeeDayWorkStatusLate() {
            // 迟到
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeDayWorkStatus).objs, "Late", "value")
        },
        valEmployeeDayWorkStatusLeaveEarly() {
            // 早退
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeDayWorkStatus).objs, "LeaveEarly", "value")
        },
        valEmployeeDayWorkStatusLateLeaveEarly() {
            // 迟到&早退
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeDayWorkStatus).objs, "LateLeaveEarly", "value")
        },
        valEmployeeDayWorkStatusLack() {
            // 缺卡
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeDayWorkStatus).objs, "Lack", "value")
        },

        // 员工角色
        valEmployeeRoleCarMover() {
            // 挪车
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeRole).objs, "CarMover", "value")
        },
        valEmployeeRoleBatterySwapper() {
            // 换电
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeRole).objs, "BatterySwapper", "value")
        },
        valEmployeeRoleInspector() {
            // 巡检
            return this.getEnumConfigsItem(this.getEnumConfigs(this.EmployeeRole).objs, "Inspector", "value")   
        },

        // 挪车状态
        valMoveTaskFlagInvalid() {
            // 无效
            return this.getEnumConfigsItem(this.getEnumConfigs(this.MoveTaskFlag).objs, "Invalid", "value")
        },
        valMoveTaskFlagEffective() {
            // 有效
            return this.getEnumConfigsItem(this.getEnumConfigs(this.MoveTaskFlag).objs, "Effective", "value")
        },
        valMoveTaskFlagInDoubt() {
            // 存疑
            return this.getEnumConfigsItem(this.getEnumConfigs(this.MoveTaskFlag).objs, "InDoubt", "value")
        },

        // 行程单状态
        valTravelBillStatusCreated() {
            // 已提交
            return this.getEnumConfigsItem(this.getEnumConfigs(this.TravelBillStatus).objs, "Created", "value")
        },
        valTravelBillStatusInQueue() {
            // 已加入队列
            return this.getEnumConfigsItem(this.getEnumConfigs(this.TravelBillStatus).objs, "InQueue", "value")
        },
        valTravelBillStatusInProcess() {
            // 执行中
            return this.getEnumConfigsItem(this.getEnumConfigs(this.TravelBillStatus).objs, "InProcess", "value")
        },
        valTravelBillStatusCompleted() {
            // 已完成
            return this.getEnumConfigsItem(this.getEnumConfigs(this.TravelBillStatus).objs, "Completed", "value")
        },
        valTravelBillStatusFailed() {
            // 已失败
            return this.getEnumConfigsItem(this.getEnumConfigs(this.TravelBillStatus).objs, "Failed", "value")
        },

        // 车辆数据变更操作
        valVehicleDataChangeActionCreate() {
            // 新增
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "Create", "value")
        },
        valVehicleDataChangeActionUpdate() {
            // 修改
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "Update", "value")
        },
        valVehicleDataChangeActionEnd() {
            // 结束
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "End", "value")
        },
        valVehicleDataChangeActionDelete() {
            // 删除
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "Delete", "value")
        },
        valVehicleDataChangeActionImportSummary() {
            // 导入汇总
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "ImportSummary", "value")
        },
        valVehicleDataChangeActionSyncEntry() {
            // 同步接入
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "SyncEntry", "value")
        },
        valVehicleDataChangeActionSyncMigrate() {
            // 同步迁移
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeAction).objs, "SyncMigrate", "value")
        },

        // 车辆数据变更实体类型
        valVehicleDataChangeEntityTypePolicy() {
            // 保单
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeEntityType).objs, "Policy", "value")
        },
        valVehicleDataChangeEntityTypeChassis() {
            // 车架
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeEntityType).objs, "Chassis", "value")
        },
        valVehicleDataChangeEntityTypeInsurance() {
            // 车辆保险
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeEntityType).objs, "Insurance", "value")
        },
        valVehicleDataChangeEntityTypeControl() {
            // 中控
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeEntityType).objs, "Control", "value")
        },
        valVehicleDataChangeEntityTypeVehicleSync() {
            // 车辆同步
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeEntityType).objs, "VehicleSync", "value")
        },

        // 车辆数据变更来源
        valVehicleDataChangeSourceImport() {
            // 导入
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeSource).objs, "Import", "value")
        },
        valVehicleDataChangeSourceManual() {
            // 手动
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeSource).objs, "Manual", "value")
        },
        valVehicleDataChangeSourceSystem() {
            // 系统
            return this.getEnumConfigsItem(this.getEnumConfigs(this.VehicleDataChangeSource).objs, "System", "value")
        }
    }
  }
  
  
  